function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-validacao");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "admin",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "adm1",
  transform: "translate(-29.000000, -285.000000)",
  fill: "#21D170",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38,165 C42.9682999,165.005459 46.9945413,169.0317 47,174 C47,178.970563 42.9705627,183 38,183 C33.0294373,183 29,178.970563 29,174 C29,169.029437 33.0294373,165 38,165 Z M38,166.469186 C33.8408461,166.469186 30.4691856,169.840846 30.4691856,174 C30.4691856,178.159154 33.8408461,181.530814 38,181.530814 C42.157645,181.527174 45.5271737,178.157645 45.5308144,174 C45.5308144,169.840846 42.1591539,166.469186 38,166.469186 Z M41.6821292,171.257988 C41.8681022,171.044921 42.153102,170.954291 42.4237037,171.022168 C42.6943053,171.090044 42.9065972,171.305413 42.9760908,171.582561 C43.0455844,171.859708 42.9610027,172.153661 42.7560078,172.34743 L42.7560078,172.34743 L37.5356706,177.777239 L37.4628898,177.833194 L37.4628898,177.833194 L37.3832273,177.878177 C37.354898,177.902212 37.3242497,177.923205 37.2917613,177.940829 C37.2015742,177.979442 37.1049032,177.999543 37.0072004,178 C36.9095331,177.999191 36.8129273,177.979103 36.7226395,177.940829 C36.6957781,177.926682 36.6707416,177.909143 36.6481117,177.888619 C36.586573,177.860356 36.5294838,177.822816 36.4787302,177.777239 L36.4787302,177.777239 L33.2164429,174.373166 C32.9245769,174.06848 32.9283687,173.578383 33.224912,173.278503 C33.5214554,172.978623 33.9984554,172.982519 34.2903215,173.287205 L34.2903215,173.287205 L37.0004251,176.130893 Z",
  id: "icon-validacao"
}))));

var SvgValidation = function SvgValidation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValidation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/validation.2b2262f0.svg";
export { ForwardRef as ReactComponent };